import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/axios';

export default function DoctorPatients() {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    api.get('/appointments?status=completed').then(r => {
      const apts = r.data.data || [];
      // Dédupliquer par patient
      const seen = new Set();
      const unique = apts.filter(a => {
        if (seen.has(a.patient_id)) return false;
        seen.add(a.patient_id); return true;
      });
      setAppointments(unique);
    }).finally(() => setLoading(false));
  }, []);

  const filtered = appointments.filter(a =>
    a.patient?.name?.toLowerCase().includes(search.toLowerCase()) ||
    a.patient?.phone?.includes(search)
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b px-4 py-3 flex items-center gap-3 sticky top-0 z-10">
        <Link to="/doctor/dashboard" className="text-green-600 font-medium">← Retour</Link>
        <h1 className="font-bold text-gray-800">Mes patients</h1>
      </div>

      <div className="max-w-lg mx-auto p-4 space-y-4">
        <input className="input-field" placeholder="🔍 Rechercher un patient..."
          value={search} onChange={e => setSearch(e.target.value)} />

        {loading ? <p className="text-center text-gray-400 py-8">Chargement...</p>
        : filtered.length === 0 ? (
          <div className="text-center py-10">
            <p className="text-4xl mb-3">👥</p>
            <p className="text-gray-500">Aucun patient trouvé</p>
          </div>
        ) : (
          <div className="space-y-3">
            {filtered.map(apt => (
              <div key={apt.patient_id} className="card">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center text-xl">
                    {apt.patient?.gender === 'female' ? '👩' : '👤'}
                  </div>
                  <div className="flex-1">
                    <p className="font-bold text-gray-800">{apt.patient?.name}</p>
                    <p className="text-sm text-gray-500">📱 {apt.patient?.phone}</p>
                    <p className="text-sm text-gray-500">📍 {apt.patient?.city || 'Non renseigné'}</p>
                  </div>
                  <Link to={'/doctor/patient/' + apt.patient_id}
                    className="text-xs bg-green-100 text-green-700 px-3 py-1.5 rounded-xl font-medium">
                    Dossier
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
